import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between align-center mb-6" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "text-h5 font-weight-bold" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "text-h5 font-weight-bold" }
const _hoisted_6 = { class: "d-flex align-center" }
const _hoisted_7 = { class: "text-h5 font-weight-bold" }
const _hoisted_8 = { class: "d-flex align-center" }
const _hoisted_9 = { class: "text-h5 font-weight-bold" }
const _hoisted_10 = { class: "d-flex align-center" }
const _hoisted_11 = { class: "flex-grow-1" }
const _hoisted_12 = { class: "ml-4" }
const _hoisted_13 = { class: "text-caption text-medium-emphasis mt-2" }
const _hoisted_14 = { class: "d-flex align-center" }
const _hoisted_15 = { class: "text-caption" }
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = { class: "d-flex flex-column h-100" }
const _hoisted_18 = { class: "d-flex justify-space-between align-center mb-1" }
const _hoisted_19 = { class: "text-caption" }
const _hoisted_20 = {
  class: "chart-container",
  style: {"height":"250px","position":"relative"}
}
const _hoisted_21 = {
  class: "d-flex align-end",
  style: {"height":"200px"}
}
const _hoisted_22 = { class: "text-caption text-center mt-2" }
const _hoisted_23 = {
  class: "chart-container",
  style: {"height":"250px","position":"relative"}
}
const _hoisted_24 = {
  class: "d-flex align-end",
  style: {"height":"200px"}
}
const _hoisted_25 = { class: "d-flex flex-column" }
const _hoisted_26 = { class: "text-caption text-center mt-2" }
const _hoisted_27 = { class: "d-flex justify-space-between mt-2" }
const _hoisted_28 = { class: "d-flex align-center" }
const _hoisted_29 = { class: "d-flex align-center" }

import { ref, computed, onMounted, onBeforeUnmount } from 'vue'

// Application FTP communication status

export default /*@__PURE__*/_defineComponent({
  __name: 'StatusView',
  setup(__props) {

const communicationStatus = ref({
    activeDevices: 18,
    totalDevices: 24,
    ftpConnections: 15,
    maxConnections: 25,
    averageSpeed: 1.8, // MB/s
    storageUsed: 468, // GB
    storageTotal: 1024, // GB
    lastUpdate: '15/04/25 09:23'
})

// Historical data for charts
const historicalSpeed = ref([
    { time: '03:00', value: 1.2 },
    { time: '06:00', value: 0.9 },
    { time: '09:00', value: 1.8 },
    { time: '12:00', value: 2.2 },
    { time: '15:00', value: 2.4 },
    { time: '18:00', value: 1.5 },
    { time: '21:00', value: 1.1 },
    { time: '00:00', value: 0.8 }
])

const dataTransfer = ref([
    { time: '03:00', uploaded: 0.8, downloaded: 1.4 },
    { time: '06:00', uploaded: 0.5, downloaded: 1.1 },
    { time: '09:00', uploaded: 1.2, downloaded: 2.3 },
    { time: '12:00', uploaded: 1.8, downloaded: 2.7 },
    { time: '15:00', uploaded: 1.5, downloaded: 2.4 },
    { time: '18:00', uploaded: 1.1, downloaded: 1.9 },
    { time: '21:00', uploaded: 0.7, downloaded: 1.3 },
    { time: '00:00', uploaded: 0.4, downloaded: 1.0 }
])

// FTP Devices
const ftpDevices = ref([
    {
        id: 1,
        name: 'StorageUnit-A1',
        location: 'Atacama, Centro',
        storageUsed: 128,
        storageTotal: 256,
        status: 'activo', // Keep user-facing text in Spanish
        statusColor: 'success',
        lastSync: '15/04/25 09:21'
    },
    {
        id: 2,
        name: 'DataLogger-B24',
        location: 'Valparaíso, Quillota',
        storageUsed: 78,
        storageTotal: 128,
        status: 'activo',
        statusColor: 'success',
        lastSync: '15/04/25 09:15'
    },
    {
        id: 3,
        name: 'StoreServer-C12',
        location: 'O\'Higgins, San Fernando',
        storageUsed: 182,
        storageTotal: 256,
        status: 'degradado',
        statusColor: 'warning',
        lastSync: '15/04/25 08:45'
    },
    {
        id: 4,
        name: 'DataUnit-D5',
        location: 'Metropolitana, Lampa',
        storageUsed: 110,
        storageTotal: 128,
        status: 'crítico',
        statusColor: 'error',
        lastSync: '14/04/25 23:12'
    },
    {
        id: 5,
        name: 'BackupNode-E3',
        location: 'Biobío, Concepción',
        storageUsed: 0,
        storageTotal: 256,
        status: 'inactivo',
        statusColor: 'error',
        lastSync: '14/04/25 15:30'
    }
])

// Recent Errors
const recentErrors = ref([
    {
        id: 1,
        device: 'DataUnit-D5',
        message: 'Espacio de almacenamiento crítico (85%)', // Keep user-facing text in Spanish
        timeAgo: '8m',
        code: 'STORAGE_CRITICAL',
        type: 'warning'
    },
    {
        id: 2,
        device: 'BackupNode-E3',
        message: 'Conexión FTP rechazada',
        timeAgo: '38m',
        code: 'FTP_CONNECTION_REFUSED',
        type: 'error'
    },
    {
        id: 3,
        device: 'StoreServer-C12',
        message: 'Transferencia completada con advertencias',
        timeAgo: '1h',
        code: 'TRANSFER_WARNING',
        type: 'warning'
    }
])

// FTP Operation Distribution
const operationDistribution = ref([
    { type: 'Descargas', count: 324, color: '#4CAF50' }, // Keep user-facing text in Spanish
    { type: 'Subidas', count: 158, color: '#2196F3' },
    { type: 'Listados', count: 487, color: '#FF9800' },
    { type: 'Eliminación', count: 95, color: '#F44336' }
])

// Data Flows between components
const dataFlows = ref([
    {
        id: 1,
        source: 'Sensores de Campo', // Keep user-facing text in Spanish
        destination: 'StorageUnit-A1',
        connectionType: 'FTP',
        status: 'activo',
        statusColor: 'success',
        rate: '1.2 MB/s'
    },
    {
        id: 2,
        source: 'DataLogger-B24',
        destination: 'Servidor Central',
        connectionType: 'FTP',
        status: 'activo',
        statusColor: 'success',
        rate: '0.8 MB/s'
    },
    {
        id: 3,
        source: 'StoreServer-C12',
        destination: 'Base de Datos',
        connectionType: 'FTP/SFTP',
        status: 'degradado',
        statusColor: 'warning',
        rate: '0.5 MB/s'
    },
    {
        id: 4,
        source: 'DataUnit-D5',
        destination: 'Servicio de Respaldo',
        connectionType: 'FTP',
        status: 'crítico',
        statusColor: 'error',
        rate: '0.2 MB/s'
    },
    {
        id: 5,
        source: 'Servidor Central',
        destination: 'BackupNode-E3',
        connectionType: 'SFTP',
        status: 'inactivo',
        statusColor: 'error',
        rate: '0 MB/s'
    }
])

// Overall system health status
const systemHealth = computed(() => {
    const operationalDevicesRatio = communicationStatus.value.activeDevices / communicationStatus.value.totalDevices;
    const operationalConnectionsRatio = communicationStatus.value.ftpConnections / communicationStatus.value.maxConnections;
    const storageAvailabilityRatio = 1 - (communicationStatus.value.storageUsed / communicationStatus.value.storageTotal);

    const averageHealth = (operationalDevicesRatio + operationalConnectionsRatio + storageAvailabilityRatio) / 3 * 100;

    if (averageHealth >= 90) return { value: averageHealth, text: 'Excelente', color: 'success' }; // Keep user-facing text in Spanish
    if (averageHealth >= 75) return { value: averageHealth, text: 'Bueno', color: 'success' };
    if (averageHealth >= 60) return { value: averageHealth, text: 'Aceptable', color: 'warning' };
    return { value: averageHealth, text: 'Crítico', color: 'error' };
})

// Refresh data every 30 seconds
const refreshData = () => {
    // API calls or service fetches to get updated data would go here
    console.log('Updating device and storage data...')
}

const deleteData = (device: any) => {
    // Data deletion implementation
    console.log(`Requesting data deletion on: ${device.name}`)
    // Logic to connect via FTP and delete data would go here
}

const syncDevice = (device: any) => {
    // Synchronization implementation
    console.log(`Synchronizing device: ${device.name}`)
    // Logic to connect via FTP and synchronize would go here
}

let intervalId: number | undefined;
onMounted(() => {
    intervalId = setInterval(refreshData, 30000)
})

onBeforeUnmount(() => {
    if (intervalId) {
        clearInterval(intervalId)
    }
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _cache[1] || (_cache[1] = _createElementVNode("div", null, [
                  _createElementVNode("h1", { class: "text-h4 font-weight-bold" }, "Estado de Dispositivos"),
                  _createElementVNode("p", { class: "text-body-1 text-medium-emphasis" }, "Monitoreo de almacenamiento y conexiones FTP ")
                ], -1)),
                _createElementVNode("div", null, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    "prepend-icon": "mdi-refresh",
                    onClick: refreshData
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode(" Actualizar ")
                    ])),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "rounded-lg",
                flat: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pb-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_v_avatar, {
                          color: "#F5F3FF",
                          size: "40",
                          class: "mr-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { color: "#8465FF" }, {
                              default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode("mdi-harddisk")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Dispositivos Activos", -1)),
                          _createElementVNode("div", _hoisted_3, _toDisplayString(communicationStatus.value.activeDevices) + "/" + _toDisplayString(communicationStatus.value.totalDevices), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_progress_linear, {
                        "model-value": (communicationStatus.value.activeDevices / communicationStatus.value.totalDevices) * 100,
                        height: "4",
                        color: "#8465FF"
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "rounded-lg",
                flat: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pb-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_v_avatar, {
                          color: "#EAF6FF",
                          size: "40",
                          class: "mr-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { color: "#4CB3FF" }, {
                              default: _withCtx(() => _cache[4] || (_cache[4] = [
                                _createTextVNode("mdi-server-network")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Conexiones FTP", -1)),
                          _createElementVNode("div", _hoisted_5, _toDisplayString(communicationStatus.value.ftpConnections) + "/" + _toDisplayString(communicationStatus.value.maxConnections), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_progress_linear, {
                        "model-value": (communicationStatus.value.ftpConnections / communicationStatus.value.maxConnections) * 100,
                        height: "4",
                        color: "#4CB3FF"
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "rounded-lg",
                flat: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pb-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_v_avatar, {
                          color: "#F0FBE6",
                          size: "40",
                          class: "mr-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { color: "#7ED957" }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode("mdi-database")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Almacenamiento", -1)),
                          _createElementVNode("div", _hoisted_7, _toDisplayString(communicationStatus.value.storageUsed) + "/" + _toDisplayString(communicationStatus.value.storageTotal) + " GB", 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_progress_linear, {
                        "model-value": (communicationStatus.value.storageUsed / communicationStatus.value.storageTotal) * 100,
                        height: "4",
                        color: "#7ED957"
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "rounded-lg",
                flat: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pb-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_v_avatar, {
                          color: "#FFF8EA",
                          size: "40",
                          class: "mr-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { color: "#FFA726" }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode("mdi-speedometer")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Velocidad Promedio", -1)),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(communicationStatus.value.averageSpeed) + " MB/s ", 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_progress_linear, {
                        "model-value": (communicationStatus.value.averageSpeed / 5) * 100,
                        height: "4",
                        color: "#FFA726"
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "rounded-lg" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: systemHealth.value.color,
                        size: "28",
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(systemHealth.value.value >= 75 ? 'mdi-shield-check' : 'mdi-shield-alert'), 1)
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _cache[10] || (_cache[10] = _createTextVNode(" Estado de Salud del Sistema "))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_v_progress_linear, {
                            "model-value": systemHealth.value.value,
                            height: "20",
                            color: systemHealth.value.color,
                            rounded: ""
                          }, {
                            default: _withCtx(({ value }) => [
                              _createElementVNode("strong", null, _toDisplayString(Math.ceil(value)) + "%", 1)
                            ]),
                            _: 1
                          }, 8, ["model-value", "color"])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_v_chip, {
                            color: systemHealth.value.color,
                            "text-color": "white"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(systemHealth.value.text), 1)
                            ]),
                            _: 1
                          }, 8, ["color"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, " Última actualización: " + _toDisplayString(communicationStatus.value.lastUpdate), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "text-h5 font-weight-bold mb-3" }, "Dispositivos de Almacenamiento", -1)),
              _createVNode(_component_v_card, { class: "rounded-lg" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table, {
                    headers: [
                        { title: 'Dispositivo', key: 'name' },
                        { title: 'Ubicación', key: 'location' },
                        { title: 'Almacenamiento', key: 'storage' }, // Changed key to 'storage' for clarity
                        { title: 'Estado', key: 'status' },
                        { title: 'Última Sincronización', key: 'lastSync' },
                        { title: 'Acciones', key: 'actions', sortable: false },
                    ],
                    items: ftpDevices.value,
                    density: "comfortable"
                  }, {
                    [`item.storage`]: _withCtx(({ item }) => [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_v_progress_linear, {
                          "model-value": (item.storageUsed / item.storageTotal) * 100,
                          color: (item.storageUsed / item.storageTotal) > 0.85 ? 'error' : (item.storageUsed / item.storageTotal) > 0.7 ? 'warning' : 'success',
                          height: "8",
                          rounded: "",
                          class: "flex-grow-1 mr-2"
                        }, null, 8, ["model-value", "color"]),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(item.storageUsed) + "/" + _toDisplayString(item.storageTotal) + " GB", 1)
                      ])
                    ]),
                    [`item.status`]: _withCtx(({ item }) => [
                      _createVNode(_component_v_chip, {
                        color: item.statusColor,
                        size: "small",
                        "text-color": "white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.status), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    [`item.actions`]: _withCtx(({ item }) => [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_v_btn, {
                          icon: "",
                          small: "",
                          class: "mr-1",
                          onClick: ($event: any) => (syncDevice(item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                _createTextVNode("mdi-sync")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          icon: "",
                          small: "",
                          color: "error",
                          onClick: ($event: any) => (deleteData(item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => _cache[12] || (_cache[12] = [
                                _createTextVNode("mdi-delete")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-h5 font-weight-bold mb-3" }, "Flujos de Datos", -1)),
              _createVNode(_component_v_card, { class: "rounded-lg" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table, {
                    headers: [
                        { title: 'Origen', key: 'source' },
                        { title: 'Destino', key: 'destination' },
                        { title: 'Protocolo', key: 'connectionType' },
                        { title: 'Estado', key: 'status' },
                        { title: 'Tasa Transferencia', key: 'rate' }
                    ],
                    items: dataFlows.value,
                    density: "comfortable"
                  }, {
                    [`item.status`]: _withCtx(({ item }) => [
                      _createVNode(_component_v_chip, {
                        color: item.statusColor,
                        size: "small",
                        "text-color": "white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.status), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    _: 2
                  }, 1032, ["items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "text-h5 font-weight-bold mb-3" }, "Errores Recientes", -1)),
              _createVNode(_component_v_card, {
                class: "rounded-lg",
                flat: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentErrors.value, (error) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: error.id,
                          ripple: false
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_avatar, {
                              color: error.type === 'error' ? 'error' : error.type === 'warning' ? 'warning' : 'info',
                              size: "36"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { color: "white" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(error.type === 'error' ? 'mdi-alert-circle' : error.type === 'warning' ?
                                            'mdi-alert' : 'mdi-information'), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["color"])
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_v_chip, {
                              size: "small",
                              variant: "outlined"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(error.timeAgo), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(error.message), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(error.device) + " - " + _toDisplayString(error.code), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "text-h5 font-weight-bold mb-3" }, "Distribución de Operaciones FTP", -1)),
              _createVNode(_component_v_card, {
                class: "rounded-lg pa-4",
                height: "100%"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operationDistribution.value, (item, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "mb-2 flex-grow-1"
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", null, _toDisplayString(item.type), 1),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(item.count), 1)
                        ]),
                        _createVNode(_component_v_progress_linear, {
                          "model-value": (item.count / operationDistribution.value.reduce((acc, curr) => acc + curr.count, 0)) * 100,
                          color: item.color,
                          height: "12",
                          rounded: ""
                        }, null, 8, ["model-value", "color"])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "rounded-lg pa-4" }, {
                default: _withCtx(() => [
                  _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "text-h6 font-weight-bold mb-4" }, "Velocidad FTP a lo largo del día", -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historicalSpeed.value, (dataPoint, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "flex-grow-1 mx-1"
                        }, [
                          _createElementVNode("div", {
                            class: "bg-primary rounded-t",
                            style: _normalizeStyle({ height: (dataPoint.value / 3 * 100) + '%' })
                          }, null, 4),
                          _createElementVNode("div", _hoisted_22, _toDisplayString(dataPoint.time), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "rounded-lg pa-4" }, {
                default: _withCtx(() => [
                  _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "text-h6 font-weight-bold mb-4" }, "Transferencia de Datos (MB/s)", -1)),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataTransfer.value, (dataPoint, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "flex-grow-1 mx-1"
                        }, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", {
                              class: "bg-success rounded-t",
                              style: _normalizeStyle({ height: (dataPoint.downloaded / 3 * 100) + '%' })
                            }, null, 4),
                            _createElementVNode("div", {
                              class: "bg-info mt-1 rounded-t",
                              style: _normalizeStyle({ height: (dataPoint.uploaded / 3 * 100) + '%' })
                            }, null, 4)
                          ]),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(dataPoint.time), 1)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_v_avatar, {
                          size: "10",
                          class: "bg-success mr-1"
                        }),
                        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-caption" }, "Descargados", -1))
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_v_avatar, {
                          size: "10",
                          class: "bg-info mr-1"
                        }),
                        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-caption" }, "Subidos", -1))
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})